import { Component } from '@angular/core';

import { I18n } from '@ngx-translate/i18n-polyfill';
import { OrderModel } from '@core/api';
import { OrderService } from '@accounts/user/services/order.service';
import { Router } from '@angular/router';
import { MatBottomSheetRef } from '@angular/material';


@Component({
  selector: 'finish-rent',
  templateUrl: './finish-rent.component.html',
  styleUrls: ['./finish-rent.component.scss']
})
export class FinishRentComponent {

  constructor(
    private i18n: I18n,
    private bottomSheetRef: MatBottomSheetRef<FinishRentComponent>
  ) {

  }

  close() {
    this.bottomSheetRef.dismiss();
  }

}
